<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->
<div class="container-fluid ">

  <div class="col-md-6 " style="margin-left:auto; margin-right: auto; ">
    <div class="row no-pad mar-btm-30 ">
      <h2 class="col-md-12 mar-top-20 ">{{'RESET_PWD' | translate}}</h2>
    </div>
    <form #f="ngForm" novalidate (ngSubmit)="f.form.valid && save(f.value, f.valid)" novalidate>
      <div class="form-group">
        <input type="text" class="form-control" name="username" [ngModel]="user.username" required #username="ngModel"
          hidden>

      </div>
      <div class="form-group row jumbotron oldpassword">
        <label for="" class="col-sm-6 col-form-label">{{'Old Password' | translate}}
          <span class="required">*</span>
        </label>
        <div class="col-sm-6 ">
          <input type="password" class="form-control" name="oldpassword" [ngModel]="user.oldpassword" required
            #oldpassword="ngModel">
          <small [hidden]="oldpassword.valid || (oldpassword.pristine && !f.submitted)" class="text-danger">
            Old Password is required.
          </small>
        </div>
      </div>
      <div class="form-group row  mar-btm-30">
        <label for="" class="col-sm-6 col-form-label">{{'New Password' | translate}}
          <span class="required">*</span>
        </label>
        <div class="col-sm-6">
          <input type="password" class="form-control" name="password" [ngModel]="user.password" [pattern]="unamePattern"
            validateEqual="confirmPassword" reverse="true" #password="ngModel" required>
          <small *ngIf="f.submitted && password.pristine" class="text-danger">
            New Password is required
          </small>
          <div *ngIf="f.submitted && password.errors?.pattern" class="text-danger">{{'PASSWORD_CRITERIA' | translate}}
          </div>
        </div>

      </div>
      <div class="form-group row  mar-btm-30">
        <label for="" class="col-sm-6 col-form-label">{{'Confirm New Password' | translate}}
          <span class="required">*</span>
        </label>
        <div class="col-sm-6">
          <input type="password" class="form-control" name="confirmPassword" [ngModel]="user.confirmPassword" required
            validateEqual="password" reverse="false" #confirmPassword="ngModel">
          <small [hidden]="confirmPassword.valid || (confirmPassword.pristine && !f.submitted)" class="text-danger">
            Password mismatch
          </small>
        </div>
        <!--<pre *ngIf="confirmPassword.errors" class="margin-20">{{ confirmPassword.errors | json }}</pre>-->

      </div>
      <div class="form-group row ">
        <div class="col-sm-6"></div>
        <div class="col-sm-6">

          <button type="submit" value="Submit" class="btn btn-dark">{{'Change Password' | translate}}</button>
        </div>
      </div>
    </form>
  </div>
</div>